module.exports = __webpack_public_path__ + "static/media/playstore.72dc1802.svg";